/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const OpenBook = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M6 2C8.63484 2 10.6351 3.02108 12.0007 5.06324C13.3649 3.02108 15.3652 2 18 2H23V20H18C15.5 20.0343 13.75 20.701 12.75 22H11.2498C10.2499 20.701 8.5 20.0343 6 20H1V2H6ZM6 3.5H2.5V18.5L6.02059 18.5001C8.18766 18.5299 9.94859 18.9961 11.2517 19.9364L11.25 6.64L10.7538 5.89705C9.67258 4.28022 8.14419 3.5 6 3.5ZM21.5 3.5H18C15.949 3.5 14.4618 4.21382 13.3913 5.69041L13.2479 5.89649L12.75 6.64L12.7493 19.9358C13.9832 19.0465 15.6293 18.5814 17.6511 18.5086L18 18.5H21.5V3.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
